import { Flex, Text } from '@chakra-ui/react';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, MenuItem, Modal, useToast } from '@morressier/alembic';
import { useState } from 'react';
import { useDeleteWorkspaceRole } from 'src/api/mutations';

type deleteRoleProps = {
  name: string;
  displayName: string;
  workspaceId: string;
};
const DeleteRole = ({ name, workspaceId }: deleteRoleProps) => {
  const toast = useToast();
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => {
    setIsOpen(false);
  };
  const deleteRoleMutation = useDeleteWorkspaceRole(workspaceId, name);
  const onConfirm = async () => {
    const res = await deleteRoleMutation.mutateAsync();
    if (res.isSuccess) {
      toast({
        variant: 'success',
        title: 'Role Deleted',
        isClosable: true
      });
      setIsOpen(false);
    } else {
      toast({
        variant: 'error',
        title: res?.message,
        isClosable: true
      });
      setIsOpen(false);
    }
  };
  return (
    <>
      <MenuItem ariaLabel="delete-role" onClick={() => setIsOpen(true)}>
        <Text color={'red'}> Delete</Text>
      </MenuItem>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          onClose={handleClose}
          width={{ base: 'calc(100vw - 16px)', md: '448px' } as any}
        >
          <Flex padding={{ base: 4, md: 8 }} gap={6} flexDirection="column">
            <Flex flexDirection="column" gap={2}>
              <Text textStyle="headingGroup">
                <FontAwesomeIcon icon={faWarning} /> Delete Role?
              </Text>
              <Text textStyle="textBody">
                Are you sure you want to delete this Role?
              </Text>
            </Flex>

            <Flex gap={2} justifyContent="flex-end">
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="caution" onClick={onConfirm}>
                Delete
              </Button>
            </Flex>
          </Flex>
        </Modal>
      )}{' '}
    </>
  );
};
export default DeleteRole;
